import { Typography as e } from "../../Typography/Typography.mjs";
import { useEffect as t, useState as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/HomepageGreeting/HomepageGreeting.tsx
var i = ({ greetings: i, className: a }) => {
	let [o, s] = n("");
	return t(() => {
		i && i.length > 0 && s(i[Math.floor(Math.random() * i.length)]);
	}, [i]), o ? /* @__PURE__ */ r(e, {
		variant: "h2",
		as: "h1",
		className: a,
		children: o
	}) : null;
};
//#endregion
export { i as HomepageGreeting };
